/**
 * Available configuration types
 *
 * @type {{ALTERNATE: string, MASTER: string, ADD_ON: string}}
 */
export const CONFIGURATION_TYPE = {
    ADD_ON: 'add-on',
    ALTERNATE: 'alternate',
    MASTER: 'master',
};

export const DELETE_SKU_MESSAGE = {
    bcselite: `If you remove this SKU any BCS document under a company using this configuration will be removed too.`,
    handbooks: `Please note that ALL previously created handbooks will no longer be available if you remove this SKU.`,
    handbooksfederal: `Please note that ALL previously created federal handbooks will no longer be available if you remove this SKU.`,
    handbooksonestate: `Please note that ALL previously created one-state handbooks will no longer be available if you remove this SKU.`,
    handbooksmultistate: `Please note that ALL previously created multi-state handbooks will no longer be available if you remove this SKU.`,
    peohandbook: `Please note that ALL previously created PEO handbooks will no longer be available if you remove this SKU.`,
    esignature: `Please note that e-Signature data will not be deleted when the e-signature SKU is deleted`,
    learncustomcourseuploader: `Please note that ALL previously created custom course(s) will no longer be available if you remove this SKU.`,
    handbookslocalpolicies:
        'Please note that ALL previously created Local Policies handbooks will no longer be available if you remove this SKU.',
};

export const ERROR_CODE_UPDATE = '1292';
